import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { TableCell, TableRow } from 'transfix-ui/components/Table'
import { TItem } from 'apps/marketplace/pages/shippers/components/ShipperList/types'
import { EDI_TOOLS_ROUTES } from '../LandingPage'

interface IShipperConfigDetailsTableRowProps {
  shipper: TItem
}

export const ShipperConfigDetailsTableRow = memo<IShipperConfigDetailsTableRowProps>(
  ({ shipper }) => {
    const { id, name = '' } = shipper || {}

    return (
      <TableRow dataTest='shipper-table-row'>
        <TableCell dataTest='shipper-table-row-name'>
          <Link to={`${EDI_TOOLS_ROUTES.SHIPPER_CONFIG}/${id}/shipperName/${name}`}>{name}</Link>
        </TableCell>
      </TableRow>
    )
  }
)

export default ShipperConfigDetailsTableRow
